import { createSingleEntityStore } from '@recruitee/ngrx';

import { OpenQuestionsAssignedJobTemplatesList } from '../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<OpenQuestionsAssignedJobTemplatesList>()(
    'OpenQuestionsTemplatesAssignedJobTemplates',
    {
      customActions: adapter => ({
        fetch: (
          state,
          payload: { id: number; searchParams: { q: string | null; page: number; limit: number } },
        ) => adapter.markAsPending(state),
      }),
    },
  );

export {
  actions as OpenQuestionsTemplatesAssignedJobTemplatesActions,
  selectors as OpenQuestionsTemplatesAssignedJobTemplatesSelectors,
  reducer as OpenQuestionsTemplatesAssignedJobTemplatesReducer,
  namespace as OpenQuestionsTemplatesAssignedJobTemplatesNamespace,
};
